$(".FAQlink").click(function (e) {
  e.preventDefault();
  Reamaze.popup("/kb");
  // console.log('clicked');
});

$(".FAQlink-footer").click(function (e) {
  e.preventDefault();
  Reamaze.popup("/kb");
  // console.log('clicked');
});

$(".FAQlink-mobile").click(function (e) {
  e.preventDefault();
  Reamaze.popup("/kb");
  // console.log('clicked');
});

$(".subCommitment").click(function (e) {
  e.preventDefault();
  Reamaze.popup("/kb/membership-and-subscription-faq/is-there-a-minimum-commitment-to-membership");
  //console.log('clicked');
});

$(".subOnetime").click(function (e) {
  e.preventDefault();
  Reamaze.popup("/kb/membership-and-subscription-faq/how-do-i-add-a-one-time-product-to-my-subscription");
  // console.log('clicked');
});

setTimeout(function() { 
  $('.announcement-bar__text').css('visibility', 'visible');
  $('.top-bar__text').css('visibility', 'visible');
  $('.rebuy-elm').css('visibility', 'visible');
}, 1000);

/* -- Change Avis Options Cart label from Products to Includes: 
$('.cart__text .Products').hide();
var apoLabel = $('.cart__text .Products').html();
// console.log(apoLabel);
// console.log(apoLabel.split(':')[0]);
var newLabel = apoLabel.split(':')[1];
$('.cart__text .Products').html('Includes: ' + newLabel).fadeIn(300);
 -- */
/* -- Add "Starts at" to price on BYOG --- */
setTimeout(function() { 
  //$('#pdp_7772880142489 .price-ui .money').hide();
  var pdpPrice = $('#pdp_7772880142489 .price-ui .money').html();
  var pdpCustomLabel = "Starts at";
  $('#pdp_7772880142489 .price-ui .money').html(pdpCustomLabel + ' ' + pdpPrice).css('display','block');
}, 1000);

setTimeout(function() { 
    var collPrice = $('#pdp_7772880142489 .product-thumbnail__price .money').html();
    var collCustomLabel = "Starts at";
    $('#pdp_7772880142489 .product-thumbnail__price .money').html(collCustomLabel + ' ' + collPrice).css('display','block');
}, 1000);


var mobileMenuIcon = document.querySelector(".mobile-menu__toggle-icon");

mobileMenuIcon.addEventListener("click", () => {
  console.log(
    document
      .querySelector(".mobile-menu__toggle-button")
      .getAttribute("data-show-mobile-menu")
  );

  if (mobileMenuIcon.classList.contains("is-active")) {
    mobileMenuIcon.classList.remove("is-active");
    document
      .querySelector(".mobile-menu__toggle-button")
      .setAttribute("data-show-mobile-menu", false);
  } else {
    mobileMenuIcon.classList.add("is-active");
    document
      .querySelector(".mobile-menu__toggle-button")
      .setAttribute("data-show-mobile-menu", true);
  }
});

var tabBtns = document.querySelectorAll(".Timeline__NavItem");
var tabItems = document.querySelectorAll(".Timeline__Item");

var tabBtnsMob = document.querySelectorAll(".mobile__nav");
var tabItemsMob = document.querySelectorAll(".mobile__item");

if (tabBtns) {
  tabBtns.forEach((item) => {
    item.addEventListener("click", () => {
      let dataIndex = item.dataset.index;
      //console.log(dataIndex);
      //console.log(
        //document.querySelector(`.Timeline__Item[data-index='${dataIndex}']`)
      //);
      if (!item.classList.contains("is-selected")) {
        tabBtns.forEach((list) => {
          list.classList.remove("is-selected");
        });
        tabItems.forEach((list) => {
          list.classList.remove("is-selected");
        });
        item.classList.add("is-selected");
        document.querySelector(`.Timeline__Item[data-index='${dataIndex}']`).classList.add("is-selected");

        if (tabItemsMob) {
          document.querySelector(`.mobile__item[data-index='${dataIndex}']`).classList.add("is-selected");
        }
      }
    });
  });
}

// var tabBtnsMob = document.querySelectorAll(".mobile__nav");
// var tabItemsMob = document.querySelectorAll(".mobile__item");

// if (tabBtnsMob) {
//   tabBtnsMob.forEach((item) => {
//     item.addEventListener("click", () => {
//       let dataIndex = item.dataset.index;
//       console.log(dataIndex);
//       console.log(
//         document.querySelector(`.mobile__item[data-index='${dataIndex}']`)
//       );
//       if (!item.classList.contains("is-selected")) {
//         tabBtnsMob.forEach((list) => {
//           list.classList.remove("is-selected");
//         });
//         tabItemsMob.forEach((list) => {
//           list.classList.remove("is-selected");
//         });
//         item.classList.add("is-selected");
//         document
//           .querySelector(`.mobile__item[data-index='${dataIndex}']`)
//           .classList.add("is-selected");
//       }
//     });
//   });
// }
/*
document.getElementsByClassName("rebuy-rec").style.display = "none";
document.getElementsById('rebuy-widget-13008').style.display = "none";
function loadRebuy() {
    document.getElementsById('rebuy-widget-13008').style.display = "block";
    document.getElementsByClassName("rebuy-rec").style.display = "block";
}
window.onload = loadRebuy();
*/


